export default __webpack_public_path__ + "static/media/lady.6af0f363.png";